module.exports = __webpack_public_path__ + "static/media/warning-icon.9363079d.svg";